import { RowSelectionState } from "@tanstack/react-table";

export function getSelectedRowIds(rowSelection: RowSelectionState): string[] {
    return Object.entries(rowSelection)
        .filter(([, isSelected]) => isSelected)
        .map(([rowId]) => rowId);
}
